<div class="return-history">

  <section class="first-section">
    <div class="mb-3 mt-2">
      {{constantsValue.viewPastReturns}}
    </div>
  </section>

  <div class="grey-line"></div>

  <section class="second-section">
    <div class="apply-credits">
      {{constantsValue.applyCreditsTitle}}
    </div>
    <div class="mb-3 mt-2">
      {{constantsValue.viewAvailableCredits}}
    </div>
    <button class="btn-secondary" (click)="redirectToPaymentPage()">View available credits</button>
    @if (!!pastReturnsArr && pastReturnsArr.length > 0 && isLoadingDone) {
      <div id="account_invoice_financials_wrapper" class="dataTables_wrapper no-footer"
        >
        <table class="display dataTable no-footer">
          <thead>
            <tr class="heading">
              <th class="ad-date" scope="col" (click)="sortColumn($event, 'dateCreated', pastReturnsArr, 'Date')">
                Date created
                <i class="my-icon fas fa-caret-down"></i>
              </th>
              <th scope="col" class="ad-invoice" (click)="sortReturnNoColumn($event, pastReturnsArr)">
                Return #
                <i class="my-icon fas fa-caret-down"></i>
              </th>
              <th scope="col" class="ad-order ret-status"
                (click)="sortColumn($event, 'status', pastReturnsArr, 'normal')">
                Status
                <span class="help-tooltip" [ngbTooltip]="tooltiptemplate" placement="top" triggers="mouseenter:mouseleave"
                  tooltipClass="rh-status-tooltip">
                  <img src="/icons/{{baseSiteId}}/icons-help-tooltip.svg">
                </span>
              </th>
              <th scope="col" class="ad-credit his_action">Credit #</th>
              <th scope="col" class="ad-prompt his_action">Credit Date</th>
              <th scope="col" class="ad-amount-due right his_action">Credit Issued</th>
              <th scope="col" class="his_header_space"># of Shipping boxes</th>
              <th scope="col" class="his_action">Actions</th>
            </tr>
          </thead>
          <tbody>
            @for (return of pastReturnsArr; track return; let i = $index) {
              <tr>
                <td>{{return?.dateCreated | date:'MM/dd/yyyy'}}</td>
                <td class="darkblue"><a
                (click)="openReturnHistPopupPrint(return,returnNoModal,false)">{{return?.returnNo}}</a></td>
                <td class="raissued text-capitalize">{{return.status}}</td>
                <td>
                  @if (return.creditNo && billingDisplay) {
                    <span class="pdf-style"><a
                    (click)="generateInvoicePDF(return?.encryptedCreditNo)">{{return?.creditNo}}</a></span>
                  }
                  @if (return.creditNo && !billingDisplay) {
                    <span>{{return?.creditNo}}</span>
                  }
                  @if (!return.creditNo) {
                    <span>—</span>
                  }
                </td>
                <td>{{return?.creditDate | date:'MM/dd/yyyy'}}@if (!return.creditDate) {
                  <span>—</span>
                }</td>
                <td class="right">{{return?.creditIssued}}@if (!return.creditIssued) {
                  <span>—</span>
                }</td>
                <td class="rhnob">{{return?.noOfShippingBoxes}}</td>
                <td (click)="captureCurrentActionRow(return)" class="actions_dropdowns" [ngbPopover]="actionsPopup"
                  placement="bottom" triggers="click" #p1="ngbPopover">
                  <span><i class="dot-icon fas fa-ellipsis-h fa-lg"></i></span>
                </td>
              </tr>
            }
          </tbody>
        </table>
        <div class="commonViewTable">
          @for (return of pastReturnsArr; track return; let i = $index) {
            <div class="childViewTable undefined" data-class="childViewTable undefined"
              >
              <div class="commonRow">
                <label> Date created </label>
                <span class="rowData">{{return?.dateCreated}}</span>
              </div>
              <div class="commonRow darkblue">
                <label> Return # </label>
                <span class="rowData"><a
                (click)="openReturnHistPopupPrint(return,returnNoModal,false)">{{return?.returnNo}}</a></span>
              </div>
              <div class="commonRow">
                <label> Status<span class="help-tooltip" [ngbTooltip]="tooltiptemplate" placement="right"
                  triggers="mouseenter:mouseleave" tooltipClass="rh-status-tooltip">
                  <img src="/icons/{{baseSiteId}}/tooltip.svg">
                </span></label>
                <span class="rowData">{{return?.status}}</span>
              </div>
              <div class="commonRow">
                <label> Credit #</label>
                <span class="rowData">{{return?.creditNo}}@if (!return.creditNo) {
                  <span>—</span>
                }</span>
              </div>
              <div class="commonRow">
                <label> Credit Date</label>
                <span class="rowData">{{return?.creditDate}}@if (!return.creditDate) {
                  <span>—</span>
                }</span>
              </div>
              <div class="commonRow">
                <label> Credit Issued</label>
                <span class="rowData">{{return?.creditIssued}}@if (!return.creditIssued) {
                  <span>—</span>
                }</span>
              </div>
              <div class="commonRow">
                <label> # of shipping boxes</label>
                <span class="rowData">{{return?.noOfShippingBoxes}}</span>
              </div>
              <div class="commonRow">
                <label> Actions</label>
                <span (click)="captureCurrentActionRow(return)" class="rowData actions_dropdowns"
                  [ngbPopover]="actionsPopup" placement="left" triggers="click" #p1="ngbPopover"><i
                class="dot-icon fas fa-ellipsis-h fa-lg"></i></span>
              </div>
            </div>
          }
        </div>
      </div>
    }
    @if (!!pastReturnsArr && pastReturnsArr.length === 0 && isLoadingDone) {
      <div class="text-center no-returns">
        No Returns History Details Available
      </div>
    }
  </section>
  @if (pastReturnsArr.length>0) {
    <div class="pagination-row mt-4">
      @if (totalReturns > 18) {
        <p>
          {{ "ordersList.showing" | cxTranslate }}
          <span class="no_rec">{{ pageRange }}</span>&nbsp;{{ "ordersList.of" |
          cxTranslate }}
          <span class="no_rec">{{ totalReturns }}</span>&nbsp;{{ "ordersList.products" | cxTranslate }}
        </p>
      }
      @if (totalReturns > 18) {
        <p class="align-btns">
          <button [disabled]="curPage == 0" (click)="getCurrentPage('prev')" class="pagination-btns mr-2">
            <span class="chevronIconWhite prev"></span>
          </button>
          <button class="pagination-btns" [disabled]="curPage == totalPages-1" (click)="getCurrentPage('next')">
            <span class="chevronIconWhite next"></span>
          </button>
        </p>
      }
      @if (totalReturns > 18) {
        <p>
          <span>{{ "ordersList.page" | cxTranslate }} {{ curPage+1 }}
          {{ "ordersList.of" | cxTranslate }} {{ totalReturns }}</span>
        </p>
      }
    </div>
  }
  <div>
    <p class="trms_cond">
      Returns are subject to our policy, noted in our <a href="{{pdfUrl}}" target="_blank">Terms and Conditions</a>. The Terms and Conditions are subject to change without prior notification.
    </p>
  </div>

  <ng-template #returnNoModal let-modal>
    <div id="modal-content">
      <div id="printLogo" class="mt-2"><img class="logo-style"
      src="/icons/{{baseSiteId}}/logo-header.png"></div>
      <div class="modal-header header-style" ngbAutofocus>
        <h4 class="popup-title">Return Information</h4>
      </div>
      <div class="modal-body body-style">
        <div class="row">
          <section class="col-sm-8 col-md-8 col-xs-12">
            <section class="location mb-3">
              <h6 class="d-flex">
                <div><img [src]="'/icons/'+baseSiteId+'/location.svg'"></div>
                <div class="ml-1"><span>{{userInfo?.name}}({{userInfo?.uid}})</span></div>
              </h6>
            </section>
            <section>
              <div class="text-capitalize">
              {{userInfo?.shippingAddress?.line1}},&nbsp;{{userInfo?.shippingAddress?.line2}}</div>
              <div>
                {{userInfo?.shippingAddress?.town}},&nbsp;{{userInfo?.billingAddress?.country.isocode}}&nbsp;{{userInfo?.billingAddress?.postalCode}}
              </div>

            </section>
          </section>
          <section class="col-sm-4 col-md-4 col-xs-12 mt-3 no-print">
            <div class="mb-3">
              <a><img src='/icons/{{baseSiteId}}/print.svg' class="svg-images" (click)="OnPrint()"></a>
              <a class="print" (click)="OnPrint()">Print</a>
              <a class="ml-3" (click)="downloadReturnInfo(false,openedRow.returnNo)"><img
              src='/icons/{{baseSiteId}}/download-icon.svg' class="svg-images-download"></a>
              <a class="print" (click)="downloadReturnInfo(false,openedRow.returnNo)">Download</a>
            </div>
          </section>
        </div>
        <hr>

          <div class="row rh-status">
            <div class="col-lg-4 col-md-6 col-sm-8 col-xs-12">
              <h3> Return #</h3>
              <p>{{openedRow.returnNo}}</p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-4 xol-xs-12">
              <h3> Date submitted</h3>
              <p>{{openedRow.dateCreated}}</p>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-4 xol-xs-12">
              <h3> Status<span class="help-tooltip no-print"><img
                [src]="'/icons/'+baseSiteId+'/tooltip.svg'" [ngbTooltip]="tooltiptemplate"
              placement="bottom" triggers="mouseenter:mouseleave" tooltipClass="rh-status-tooltip"></span></h3>

              <p>{{openedRow.status}}</p>
            </div>

          </div>

          <div>
            <table class="bgtable credits-table bgc-table mrl d-none d-xl-block d-lg-block">
              <thead>
                <tr class="heading">
                  <th class="ret_prod pcol1 col-xs-12 col-sm-4 col-md-4 col-lg-4">Product</th>
                  <th class="ret_prod pcol2 col-xs-12 col-sm-3 col-md-3 col-lg-3">NDC #</th>
                  <th class="ret_prod pcol3 col-xs-12 col-sm-3 col-md-3 col-lg-3">Lot #</th>
                  <th class="ret_prod pcol4 col-xs-12 col-sm-2 col-md-2 col-lg-21">Doses to return</th>
                </tr>
              </thead>
              <tbody>
                @for (product of openedRow?.returnDataList; track product) {
                  <tr>
                    <td class="ret_prod_data dcol1 text-left" [innerHTML]="product.productName"></td>
                    <td class="ret_prod_data dcol2">{{product.ndcNumber}}</td>
                    <td class="ret_prod_data dcol3">{{product.lotNumber}}</td>
                    <td class="ret_prod_data dcol4">{{product.returnDoses}}</td>
                  </tr>
                }
              </tbody>
            </table>

            <div class="d-sm-block d-md-block d-lg-none mobileTable">
              @for (product of openedRow?.returnDataList; track product) {
                <div class="childViewTableMobile">
                  <div class="commonRow">
                    <label> Product </label>
                    <span class="rowData" [innerHTML]="product.productName"></span>
                  </div>
                  <div class="commonRow">
                    <label> NDC # </label>
                    <span class="rowData">{{product.ndcNumber}}</span>
                  </div>
                  <div class="commonRow">
                    <label> Lot # </label>
                    <span class="rowData">{{product.lotNumber}}</span>
                  </div>
                  <div class="commonRow">
                    <label> Doses to return </label>
                    <span class="rowData">{{product.returnDoses}}</span>
                  </div>
                </div>
              }
            </div>
          </div>


          <!--Next stpes-->
          <section class="next-step">
            <section>
              <p><img class="mr-2" src='/icons/{{baseSiteId}}/warning.svg'>{{constantsValue.nextStep}}</p>
              <div class="d-flex">
                <div class="circle-style">1</div>
                <div class="mb-2">{{constantsValue.nextStepFirst}}</div>
              </div>
              <div class="d-flex">
                <div class="circle-style">2</div>
                <div class="mb-2"><span>{{constantsValue.nextStepSecond}}&nbsp;</span><span
              class="font-weight-bold">{{constantsValue.nextStepThird}}</span></div>
            </div>
            <div class="d-flex">
              <div class="circle-style">3</div>
              <div>{{constantsValue.nextStepFourth}}</div>
            </div>
          </section>
        </section>
        <!--Important notes-->
        <section class="imp_notes">
          <div class="mt-4 mb-2">IMPORTANT NOTES</div>
          <ul>
            <li><span>{{constantsValue.noteFirst}}</span></li>
            <li><span>{{constantsValue.noteSecond}}</span><span> {{constantsValue.noteThird}}</span></li>
            <li><span>{{constantsValue.noteBarcode}}</span><span> {{constantsValue.noteshipping}}</span></li>
            <li><span>{{constantsValue.noteNotLabel}}</span></li>
            <li><span>{{constantsValue.noteNotCover}}</span><span> {{constantsValue.noteLable}}</span></li>
          </ul>
        </section>

        <!--Shipping Address-->
        <section class="text-left mt-4 shipping-address">
          <div class="mb-3">SHIPPING ADDRESS</div>
          <div>Inmar RX Solutions</div>
          <span>3845 Grand Lakes Way,</span><span>Suite 125</span>
          <div class="mb-4">Grand Prairie, TX 75050</div>
        </section>

        <section class="text-left">
          <div>
            {{constantsValue.extraBoxes}}
          </div>
          <div>
            {{constantsValue.additionalRAs}}
          </div>
          <div class="text-policy">Returns are subject to our policy, noted in our <a href="{{pdfUrl}}"
          target="_blank">Terms & conditions</a>
        </div>
      </section>

    </div>
    <div class="modal-footer footer-style">
      <div class="col-md-12 col-lg-12 col-sm-12">
        <section class="d-flex flex-column justify-content-center btn-style">
          <button type="button" class="btn-primary mb-2" (click)="rePrintRALabels()">
            <img [src]="'/icons/'+baseSiteId+'/download-icon.svg'">
            Download RA labels
          </button>
          <button type="button" class="btn-secondary mb-2" (click)="closePopup()">
            Close
          </button>
        </section>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #tooltiptemplate>
  <div class="popover-content">
    <p class="tooltip_para">
      <b>RA issued:</b> Return initiated by submitting return form; return box(es) still need to be shipped to Inmar
    </p>
    <p class="tooltip_para">
      <b>Received:</b> Shipped return box(es) received by Inmar
    </p>
    <p class="tooltip_para">
      <b>Processed:</b> Return processed by Inmar and details sent to Sanofi Pasteur
    </p>
    <p class="tooltip_para">
      <b>Complete:</b> Return complete and credit issued as applicable
    </p>
  </div>
</ng-template>
<ng-template #actionsPopup>
  <ul class="drpdown">
    <div class="dropdown_box">
      <div class="dropdown_container">
        <li class="issuedli"><a (click)="openAddShippingBoxPopup(addShippingBoxesModal)">Add shipping boxes &amp;
        additional RAs</a></li>
        <li class="issuedli"><a (click)="rePrintRALabels()">Reprint issued RA labels</a></li>
        <li class="issuedli"><a (click)="downloadReturnInfo(true)">Download return information</a></li>
        <li class="issuedli"><a (click)="openReturnHistPopupPrint('',returnNoModal,true)">Print return information</a>
      </li>
    </div>
  </div>
</ul>
</ng-template>

<ng-template #addShippingBoxesModal let-modal>
  <div class="modal-header addShipping-header-style" ngbAutofocus>
    <h4 class="popup-title modal-title-top10">Add Shipping Boxes</h4>
    <span class="close-banner" aria-label="Close"
      style=" background-image: url(/icons/{{baseSiteId}}/close.svg);"
      (click)="closePopupAndCallApi()">
    </span>
  </div>
  <div class="modal-body addShipping-body-style">
    @if (page===1) {
      <div>
        <p class="RA-box">Add shipping boxes to print additional Return Authorizations (RAs).
          This will generate a unique RA label for each box you add. RA labels must not be photocopied or reused.
        </p>
        <div class="row unit-calc">
          <div class="col-md-12 col-sm-12 col-xs-12 unitCount-comp">
            <p class="box-count">PREVIOUS BOX COUNT: <span
            class="oldBoxQty">{{currentActionRow.noOfShippingBoxes}}</span>
          </p>
          <div class="addUnits-head bold-12"># of additional boxes</div>
          <div class="add-units">
            <span class="decQty dsbld">
              @if (boxQty.value>1) {
                <img [src]="'/icons/'+baseSiteId+'/less.svg'" alt="-"
                  (click)="incDecShippingBoxCount('minus')">
              }
              @if (boxQty.value<=1) {
                <img [src]="'/icons/'+baseSiteId+'/less-disable_new.svg'" alt="">
              }
            </span>
            <span><input type="text" maxlength="2" class="prodQuantity" name="shippingBoxQty"
              [(ngModel)]="shippingBoxCount" #boxQty (keyup)="checkshippingBoxQty('keyup')"
            (blur)="checkshippingBoxQty('blur')" (keydown)="validateInput($event)"></span>
            <span class="addQty">
              @if (boxQty.value<99) {
                <img [src]="'/icons/'+baseSiteId+'/more.svg'" alt="+"
                  (click)="incDecShippingBoxCount('plus')">
              }
              @if (boxQty.value>=99) {
                <img [src]="'/icons/'+baseSiteId+'/more-disable.svg'" alt="+">
              }
            </span>
          </div>
        </div>
      </div>
    </div>
  }
  @if (page===2) {
    <div>
      <div class="RA-box">
        <div><span><img [src]="'/icons/'+baseSiteId+'/confirmation-positive-green.png'"
          alt=""></span><span class="ml-2">You've successfully added</span><span
        class="font-weight-bold ml-1 mr-1">{{shippingBoxCount}}</span><span>more
      boxes</span></div>
      <div><span>for a </span><span class="font-weight-bold">new total</span><span class="ml-1 mr-1">of</span><span
    class="font-weight-bold">{{totalBoxes +' boxes'}}</span></div>
  </div>
</div>
}
</div>
<div class="modal-footer addShipping-footer-style">
  <div class="change-request-btngrps text-center">
    <button type="button" class="btn-primary w-100" [disabled]="shippingBoxCount<1"
      (click)="page==1?updateShippingBox(currentActionRow.noOfShippingBoxes):downloadRALabels()">
      @if (page==2) {
        <img [src]="'/icons/'+baseSiteId+'/download-icon.svg'">
      }
      {{page==1?'Update':'Download additional RA labels'}}
    </button>
  </div>
</div>
</ng-template>
</div>
